import api from './api';

export interface Vendedor {
    nroVendedor: number;
    nombreVendedor: string;
    nroCuentaLiquidacion?: number;
    comisionPorc?: number;
    comisionBase?: string;
    lockLiquidacion?: number;
    direccion?: string;
    codigoCiudad?: number;
    dni?: number;
    legajo?: string;
    telefono?: string;
    remuneracion?: number;
    notas?: string;
    lunes?: number;
    martes?: number;
    miercoles?: number;
    jueves?: number;
    viernes?: number;
    sabado?: number;
    domingo?: number;
    horaElun?: string | null;
    horaSlun?: string | null;
    horaEmar?: string | null;
    horaSmar?: string | null;
    horaEmie?: string | null;
    horaSmie?: string | null;
    horaEjue?: string | null;
    horaSjue?: string | null;
    horaEvie?: string | null;
    horaSvie?: string | null;
    horaEsab?: string | null;
    horaSsab?: string | null;
    horaEdom?: string | null;
    horaSdom?: string | null;
    turno?: number;
    comisionServicio?: number;
    comisionBaseServicio?: string;
    nroProveedor?: number;
    tipoVendedor?: string;
    referenciaErp?: string | null;
    sincronizar?: number;
    grupoMcpMobile?: number;
    usuario?: string;
}

export interface VendedorSearchParams {
    searchTerm?: string;
    pageNumber?: number;
    pageSize?: number;
    nombre?: string;
    legajo?: string;
    tipoVendedor?: string;
    usuario?: string;
}

export interface VendedorPagedResult {
    items: Vendedor[];
    totalCount: number;
    pageNumber: number;
    pageSize: number;
    totalPages: number;
}

const vendedorService = {
    getVendedores: async (params?: VendedorSearchParams): Promise<Vendedor[]> => {
        const response = await api.get<Vendedor[] | VendedorPagedResult>('/api/Vendedores', params ? { params } : {});
        const data = response.data;
        
        if (Array.isArray(data)) {
            return data;
        }
        
        if (data && typeof data === 'object' && 'items' in data) {
            return data.items as Vendedor[];
        }
        
        return [];
    },

    getVendedoresPaged: async (params: VendedorSearchParams): Promise<VendedorPagedResult> => {
        const response = await api.get('/api/Vendedores', { params });
        const data = response.data;
        
        if (Array.isArray(data)) {
            return {
                items: data,
                totalCount: data.length,
                pageNumber: params.pageNumber || 1,
                pageSize: params.pageSize || 10,
                totalPages: Math.ceil(data.length / (params.pageSize || 10))
            };
        }
        
        if (data && typeof data === 'object' && 'items' in data) {
            return data as VendedorPagedResult;
        }
        
        return {
            items: [],
            totalCount: 0,
            pageNumber: params.pageNumber || 1,
            pageSize: params.pageSize || 10,
            totalPages: 0
        };
    },

    getVendedor: async (nroVendedor: number): Promise<Vendedor> => {
        const response = await api.get<Vendedor>(`/api/Vendedores/${nroVendedor}`);
        return response.data;
    },

    createVendedor: async (vendedor: Vendedor): Promise<Vendedor> => {
        const response = await api.post<Vendedor>('/api/Vendedores', vendedor);
        return response.data;
    },

    updateVendedor: async (nroVendedor: number, vendedor: Vendedor): Promise<void> => {
        await api.put(`/api/Vendedores/${nroVendedor}`, vendedor);
    },

    deleteVendedor: async (nroVendedor: number): Promise<void> => {
        await api.delete(`/api/Vendedores/${nroVendedor}`);
    }
};

export default vendedorService;

